import * as React from 'react';
import { withLocalize, LocalizeContextProps, Translate } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Row, Col } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { EnhancedProps } from 'src/pages/student/models/props';
import AudioPlayer from "src/components/common/AudioPlayer";
import AudioTranslations from "src/constants/AudioTranslations";
import InfoBox from "src/components/mission/InfoBox";
import { Planets } from "src/constants/Planets";

export interface StudentRewardProps extends EnhancedProps, LocalizeContextProps {
}

interface StudentRewardState {
    translationKey: string;
    translationStep: number;
    translationArray: string[];
}

/**
 * Dialog box with only body text and a next arrow button
 * Contains terrain, star pilot, and star pod
 */
class StudentReward extends React.Component<StudentRewardProps, StudentRewardState> {
    constructor(props: StudentRewardProps) {
        super(props);
        bindAllOfThis(this, StudentReward.prototype);

        this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
    }

    componentDidMount(): void {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillUnmount() {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillReceiveProps(nextProps: StudentRewardProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    }

    handleKeyPress(event): void {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    }

    hasNextButton(): boolean {
        return true;
    }

    hasBackButton(): boolean {
        return true;
    }

    onNext() {
        // Update the state step first
        let step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    }

    onBack() {
        // Update the state step first (go backwards)
        let step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    }

    deriveStateFromProps(newProps: StudentRewardProps) {
        let translatedKey = "student.reward.body"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        let translatedText = newProps.translate(translatedKey).toString();
        let translatedArray = (translatedText || "").split("|").map(x => x.trim());
        let translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;

        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        } as StudentRewardState);
    }

    renderHeader() {
        if (this.state.translationStep === 0) {
            let headerTranslateKey = "student.reward.header".replace("%game%", (this.props.currentGame || { name: "" }).name);
            return <h3><Translate id={headerTranslateKey} /></h3>;
        }
        return null;
    }

    render() {
        let badgeStyle: React.CSSProperties = { width: 141, height: 150 };
        let planetCode: string = (this.props.currentPlanet || { name: "" }).name.toLowerCase() as string;
        let currentDialog: string = (this.state.translationArray || [""])[this.state.translationStep];

        let translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = `${translationKey}.part${this.state.translationStep + 1}`;
        }
        let audioTrans = AudioTranslations.FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);

        return <div>
            <Row>
                <Col className="dialog-content" xs={{ span: 22, push: 1 }} md={{ span: 18 }} lg={16} xl={14}>
                    <Row>
                        <DialogBox
                            currentGrade={this.props.currentGrade}
                            currentPlanet={this.props.currentPlanet}
                            buttonNextType={this.hasNextButton() ? "arrow" : "none"}
                            buttonBackType={this.hasBackButton() ? "arrow" : "none"}
                            onBack={this.onBack}
                            onNext={this.onNext}>
                                {this.renderHeader()}
                                <p>{currentDialog}</p>
                                <img src={Planets.FindById(this.props.Mission.current.planetId).badgePath} alt="Planet Badge" style={badgeStyle} />
                        </DialogBox>
                    </Row>
                </Col>

            </Row>
            <div className={`star-pilot star-pilot-${planetCode}`} />
            <div className={`star-pod star-pod-landed star-pod-${planetCode}-landed`} />
            <div className={`planet-terrain planet-terrain-${planetCode}`} />
        </div>;
    }
}

export default withLocalize(StudentReward);



// WEBPACK FOOTER //
// ./src/pages/student/scenes/StudentReward.tsx